<template>
  <div class="esp_menu_wrap">
    <div class="esp_head">
      <img :src="logoUrl"/>
    </div>

    <div class="esp_body">
      <el-scrollbar class="esp_scrollbar">
        <el-menu @select="selectedMenu"
                 active-text-color="#495065"
                 background-color="#ffffff"
                 text-color="#495065"
                 class="esp_vertical"
                 collapse-transition>

          <el-menu-item  class="esp_home_item" @click="handleMenuClick('/home')">
            <img :src="this.activeMenu === '/home'
                ? require('@/assets/menu/home-active.png')
                : require('@/assets/menu/home.png')"
                 style="width: 20px; margin-right: 15px; vertical-align: middle;">
            <span slot="title" :class="{'active-menu-text': activeMenu === '/home'}">{{this.$t("menu_home")}}</span>
            <div class="menu-divider"></div>
          </el-menu-item>

          <el-menu-item class="esp_home_item" @click="handleMenuClick('/videoPlay')">
            <img :src="this.activeMenu === '/videoPlay'
                ? require('@/assets/menu/video-play-active.png')
                : require('@/assets/menu/video-play.png')"
                 style="width: 20px; margin-right: 15px; vertical-align: middle;">
            <span slot="title" :class="{'active-menu-text': activeMenu === '/videoPlay'}">{{this.$t("menu_video_funscripts_player")}}</span>
            <div class="menu-divider"></div>
          </el-menu-item>
          <el-menu-item class="esp_home_item" @click="handleMenuClick('/motions')">
            <img :src="this.activeMenu === '/motions'
                ? require('@/assets/menu/custom-motions-active.png')
                : require('@/assets/menu/custom-motions.png')"
                 style="width: 20px; margin-right: 15px; vertical-align: middle;">
            <span slot="title" :class="{'active-menu-text': activeMenu === '/motions'}">{{this.$t("menu_custom_motions")}}</span>
            <div class="menu-divider"></div>
          </el-menu-item>
          <el-menu-item class="esp_home_item" @click="handleMenuClick('/remote')">
            <img :src="this.activeMenu === '/remote'
                ? require('@/assets/menu/remote-play-active.png')
                : require('@/assets/menu/remote-play.png')"
                 style="width: 20px; margin-right: 15px; vertical-align: middle;">
            <span slot="title" :class="{'active-menu-text': activeMenu === '/remote'}">{{this.$t("menu_remote_play")}}</span>
            <div class="menu-divider"></div>
          </el-menu-item>
          <el-menu-item class="esp_home_item" @click="handleMenuClick('/softwares')">
            <img :src="this.activeMenu === '/softwares'
                ? require('@/assets/menu/softwares-active.png')
                : require('@/assets/menu/softwares.png')"
                 style="width: 20px; margin-right: 15px; vertical-align: middle;">
            <span slot="title" :class="{'active-menu-text': activeMenu === '/softwares'}">{{this.$t("menu_softwares")}}</span>
            <div class="menu-divider"></div>
          </el-menu-item>
<!--          <el-menu-item class="esp_home_item" @click="handleMenuClick('/searchFun')">-->
<!--            <img :src="this.activeMenu === '/searchFun'-->
<!--                ? require('@/assets/menu/search-fun-active.png')-->
<!--                : require('@/assets/menu/search-fun.png')"-->
<!--                 style="width: 20px; margin-right: 15px; vertical-align: middle;">-->
<!--            <span slot="title" :class="{'active-menu-text': activeMenu === '/searchFun'}">{{this.$t("menu_search_fun")}}</span>-->
<!--            <div class="menu-divider"></div>-->
<!--          </el-menu-item>-->
          <el-menu-item class="esp_home_item" @click="handleMenuClickForGuide('/guide')">
            <img :src="this.activeMenu === '/guide'
                ? require('@/assets/menu/user-guide-active.png')
                : require('@/assets/menu/user-guide.png')"
                 style="width: 20px; margin-right: 15px; vertical-align: middle;">
            <span slot="title" :class="{'active-menu-text': activeMenu === '/guide'}">{{this.$t("menu_user_guide")}}</span>
            <div class="menu-divider"></div>
          </el-menu-item>
<!--          <el-menu-item class="esp_home_item" @click="handleMenuClickForResource('/resource')">-->
<!--            <img :src="this.activeMenu === '/resource'-->
<!--                ? require('@/assets/menu/resource-active.png')-->
<!--                : require('@/assets/menu/resource.png')"-->
<!--                 style="width: 20px; margin-right: 15px; vertical-align: middle;">-->
<!--            <span slot="title" :class="{'active-menu-text': activeMenu === '/resource'}">{{this.$t("menu_resource")}}</span>-->
<!--            <div class="menu-divider"></div>-->
<!--          </el-menu-item>-->
          <el-menu-item class="esp_home_item" @click="handleMenuClickForProducts('/products')">
            <img :src="this.activeMenu === '/products'
                ? require('@/assets/menu/our-products-active.png')
                : require('@/assets/menu/our-products.png')"
                 style="width: 20px; margin-right: 15px; vertical-align: middle;">
            <span slot="title" :class="{'active-menu-text': activeMenu === '/products'}">{{this.$t("menu_our_products")}}</span>
            <div class="menu-divider"></div>
          </el-menu-item>

          <!-- 修改为可展开的子菜单 -->
          <el-submenu popper-class="account-submenu">
            <template slot="title" @click.native="handleMenuClick('/account')">
              <img :src="activeMenu === '/account'
                  ? require('@/assets/menu/my-account-active.png')
                  : require('@/assets/menu/my-account.png')"
                           style="width: 20px; margin-left: 5px;margin-right: 15px; vertical-align: middle;">
              <span :class="{'active-menu-text': activeMenu === '/account'}">
                {{this.$t("menu_my_account")}}
              </span>
            </template>
            <div class="account-popup">
              <div class="popup-section">
                <el-menu-item class="esp_sub_item" @click="handleMenuClick('/profile')" >
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <span :class="{'active-menu-text': activeMenu === '/profile'}">{{this.$t("menu_my_profile")}}</span>
                </el-menu-item>
                <el-menu-item class="esp_sub_item" @click="handleMenuClick('/privacy')">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <span :class="{'active-menu-text': activeMenu === '/privacy'}">{{this.$t("menu_privacy_policy")}}</span>
                </el-menu-item>
                <el-menu-item class="esp_sub_item" @click="handleMenuClick('/terms')">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <span :class="{'active-menu-text': activeMenu === '/terms'}">{{this.$t("menu_terms_of_service")}}</span>
                </el-menu-item>
                <el-menu-item class="esp_sub_item" @click="setLanguage()">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <span >{{this.$t("menu_language")}}</span>
                </el-menu-item>
                <el-menu-item class="esp_sub_item" @click="handleMenuClick('/becomeMember')">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <span :class="{'active-menu-text': activeMenu === '/becomeMember'}">{{this.$t("menu_member")}}</span>
                </el-menu-item>
                <el-menu-item class="esp_sub_item" @click="handleMenuClick('/subscriptions')">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <span :class="{'active-menu-text': activeMenu === '/subscriptions'}">{{this.$t("menu_subscription_record")}}</span>
                </el-menu-item>
                <el-menu-item class="esp_sub_item logout-item" @click="exit_system()">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <span>{{this.$t("menu_logout")}}</span>
                </el-menu-item>
              </div>
            </div>
          </el-submenu>


<!--          <el-submenu index="demo" popper-class="account-submenu">-->
<!--            <template slot="title">-->
<!--              <i class="esp_icon el-icon-s-grid"></i>-->
<!--              <span>调试DEMO</span>-->
<!--            </template>-->
<!--            <div class="account-popup">-->
<!--              <div class="popup-section">-->
<!--                <el-menu-item class="esp_sub_item" @click="handleMenuClick('/SPort')">-->
<!--                  <img :src="activeMenu === '/profile' ? activeIcon : menuIcon"-->
<!--                       style="width: 20px;margin: 5px 5px 5px 0px;"/>-->
<!--                  <span>串口通信</span>-->
<!--                </el-menu-item>-->

<!--                <el-menu-item class="esp_sub_item" @click="handleMenuClick('/MotionProfile')">-->
<!--                  <img :src="activeMenu === '/profile' ? activeIcon : menuIcon"-->
<!--                       style="width: 20px;margin: 5px 5px 5px 0px;"/>-->
<!--                  <span>MotionProfileDEMO</span>-->
<!--                </el-menu-item>-->

<!--                <el-menu-item class="esp_sub_item" @click="handleMenuClick('/SVideo')">-->
<!--                  <img :src="activeMenu === '/profile' ? activeIcon : menuIcon"-->
<!--                       style="width: 20px;margin: 5px 5px 5px 0px;"/>-->
<!--                  <span>Video</span>-->
<!--                </el-menu-item>-->

<!--              </div>-->
<!--            </div>-->
<!--          </el-submenu>-->

        </el-menu>
      </el-scrollbar>
    </div>

<!--    <el-dialog class="logout-dialog-overlay" :visible.sync="logoutDialogVisible" width="20%" center>-->
      <div v-if="logoutDialogVisible" class="logout-dialog-overlay">
        <div class="logout-dialog">
          <div class="logout-dialog-title"><span>{{this.$t('login_out')}}</span></div>
          <div class="logout-dialog-buttons">
            <button class="dialog-btn cancel-btn" @click="logoutDialogVisible = false">{{this.$t("layout_cancel")}}</button>
            <button class="dialog-btn confirm-btn" @click="confirmLogout">{{this.$t("layout_confirm")}}</button>
          </div>
        </div>
      </div>

    <el-dialog
      :title="this.$t('menu_language')"
      :visible.sync="languageDialogVisible" width="360px" center class="language-dialog">
      <div class="language-dialog-content">
        <div class="language-buttons">
          <el-button @click="changeLanguage('en')">English</el-button>
          <el-button @click="changeLanguage('ja')">Janpanese</el-button>
        </div>
      </div>
    </el-dialog>

<!--    </el-dialog>-->

  </div>
</template>

<script>
import * as cache from "@/utils/cache";
import * as menu from "@/api/platform/menu";
import {setup} from "../../../locales";

export default {
  name: "EspAside",
  data() {
    return {
      logoUrl: require("@/assets/logo/logo_big.png"),
      activeIcon: require("@/assets/images/menu/check_1.svg"),
      menuIcon: require("@/assets/images/menu/menu.png"),
      activeMenu: "home",
      myMenuList: [],
      logoutDialogVisible: false,
      languageDialogVisible: false
    }
  },
  methods: {
    // 选择菜单(若无token时,跳入登录页)
    selectedMenu: function (index) {
      var token = cache.getToken();
      if (token) {
        this.activeMenu = index;
        if (index == "/home") {
          window.parent.crumbsMenu({name: "home", isIndex: true, fullPath: "/home"});
        }

        // 处理登出逻辑
        if (index === "/logout") {
          this.$router.push("/login");
          cache.removeAuth();
          return;
        }

        this.$emit("selectedAfter", index);
      } else {
        this.$router.push({
          path: "/login"
        });
      }
    },
    handleMenuClickForResource(path) {
      this.activeMenu = path;
      window.open('https://mirabotx.co.jp/honey-collection/', '_blank');
      return;
    },
    handleMenuClickForGuide(path) {
      this.activeMenu = path;
      window.open('https://mirabotx.co.jp/user-guide/', '_blank');
      return;
    },
    handleMenuClickForProducts(path) {
      this.activeMenu = path;
      window.open('https://mirabotx.co.jp', '_blank');
      return;
    },

    handleMenuClick(path) {
      this.activeMenu = path;
      //路径不同才跳，避免重复跳转的问题
      if (this.$route.path !== path) {
        this.$router.push(path);
      }else{
        if (path === '/remote') {
          location.reload();
        }
      }
    },
    // 退出系统
    // 退出系统
    exit_system: function () {
      this.logoutDialogVisible = true;
    },
    setLanguage: function () {
      this.languageDialogVisible = true;
    },

    confirmLogout: function() {
      this.logoutDialogVisible = false;
      this.$router.push({
        path: "/login",
        name: "login"
      });
      cache.removeAuth();
    },
    changeLanguage(lang) {
      this.$i18n.locale = lang
      setup(lang);
      location.reload() // 为了重新实例化vue-router对象，避免一些bug
    },
    getLanguage() {
      console.log(navigator.language); // 输出例如 "ja-JP" 或 "ja"
      if (navigator.language.startsWith('ja')) {
        this.changeLanguage('ja')
      } else if (navigator.language.startsWith('en')) {
        this.changeLanguage('en')
      }else {
        this.changeLanguage('en')
      }
    },
    // 替换logo
    replace_logo: function (logoUrl) {
      var oThis = this;
      var logo = document.getElementsByClassName("esp_head")[0];
      var img = logo.getElementsByTagName("img")[0];

      var number = 35;
      var speed = -10;
      var timer_1 = setInterval(function () {
        if (number >= 0) {
          number = number + speed;
          img.style.height = number + "px";
        } else {
          clearInterval(timer_1);
          oThis.logoUrl = logoUrl;

          var timer_2 = setInterval(function () {
            if (number <= 30) {
              number = number - speed;
              img.style.height = number + "px";
            } else {
              clearInterval(timer_2);
            }
          }, 5);
        }
      }, 5);
    }
  },
  created: function () {
    menu.listMyMenuTree().then(resp => {
      if (resp.data) {
        this.myMenuList = resp.data;
      }
    }).catch(error => {
    });
    this.selectedMenu("/home");
  },
  watch: {
    isCollapse: function (newVal, oldVal) {
      if (newVal) {
        this.replace_logo(require("@/assets/logo/logo_small.png"));  // 换小logo
      } else {
        this.replace_logo(require("@/assets/logo/logo_big.png"));    // 换大logo
      }
    }
  },
  computed: {
    isCollapse: {
      get: function () {
        return this.$store.state.uiparam.isCollapse;
      },
      set: function (value) {
        this.$store.state.uiparam.isCollapse = value;
      }
    }
  }
}
</script>

<style lang="less">
.esp_menu_wrap {
  height: 100%;
  background-color: #ffffff;
  .active-menu-text {
    font-weight: bold !important;
    color: #7200D6 !important;
  }
  .esp_head {
    height: 10px;
    line-height: 10px;
    text-align: center;
    overflow: hidden;

    img {
      height: 35px;
      vertical-align: middle;
    }
  }

  .esp_body {
    height: calc(100% - 75px);

    .el-menu {
      border-right: none;

      &.esp_vertical:not(.el-menu--collapse) {
        width: 100%;
        margin-left: -5px;
      }

      &.el-menu--collapse {
        .el-submenu__title > span,
        .el-submenu__title > .el-submenu__icon-arrow {
          display: none;
        }
      }

      .el-submenu__icon-arrow {
        display: none;
      }

      &.el-menu--inline li {
        padding-left: 16px !important;
      }

      .el-submenu__title {
        padding-left: 15px !important;
      }

      .esp_home_item i {
        margin-left: -5px;
      }

      .esp_icon {
        color: #0f80c3;
        font-size: 20px;
      }
    }
  }
}

.el-menu-item {
  &.is-active {
    background-color: #FFFFFF !important;
  }

  /* 新增下划线样式 */
  position: relative;

  .menu-divider {
    position: absolute;
    bottom: 0;
    left: 0px;
    right: 0px;
    height: 1px;
    background-color: #f0f0f0;
  }
}

/* 账户弹出菜单样式 */
.account-submenu {
  .el-menu--popup {
    min-width: 100%;
    padding: 0;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

    .account-popup {
      padding: 10px 0;
      border: 1px solid #f0f0f0;
    }

    .popup-section {
      padding: 0 15px;
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0;
      }
      .section-title {
        color: #7f8c8d;
        font-size: 12px;
        padding: 5px 0;
        text-transform: uppercase;
      }
    }

    /* 添加菜单图标样式 */

    .menu-icon {
      width: 20px;
      margin-right: 5px;
      vertical-align: middle;
    }

    .esp_sub_item {
      height: 36px;
      line-height: 36px;
      margin: 2px 0;
      /* 新增：激活状态的背景色 */
      //&.is-active {
        background-color: #F3E5FF; /* 浅紫色 */
      //}
      span {
        font-size: 14px;
      }

      &.logout-item {
        color: #f56c6c;

        &:hover {
          color: #f56c6c;
        }
      }
    }
  }
}

/* 调整子菜单箭头位置 */
.el-submenu__title .el-submenu__icon-arrow {
  right: 5px;
  margin-top: -6px;
}

.el-menu-item:hover,
.el-submenu__title:hover {
  background-color: #F5F6F7 !important;
}

.esp_menu_wrap .el-menu .esp_home_item,
.esp_menu_wrap .el-menu .el-submenu__title,
.esp_menu_wrap .el-submenu .el-menu-item,
.el-menu--vertical .el-menu--popup .el-menu-item {
  width: 100%;
  min-width: 0px;
  margin: 0px auto;
  //border-radius: 8px;
}
.esp_home_item img {
  vertical-align: middle;
  margin-top: -2px; /* 微调垂直位置 */
}
.logout-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.logout-dialog {
  background-color: white;
  padding: 20px;
  width: 400px;
  height: 150px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px; /* 添加圆角 */
}

.logout-dialog-title {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  font-size: 16px;
}

.logout-dialog-buttons {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-top: 30px;
}

.dialog-btn {
  padding: 8px 35px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.cancel-btn {
  background-color: #F4F3F1;
  color: #AA81FF;
  border: 1px solid #AA81FF;
}

.cancel-btn:hover {
  background-color: #e0e0e0;
}

.confirm-btn {
  background-color: #AA81FF;
  color: white;
  border: none;
}

.confirm-btn:hover {
  background-color: #7200D6;
}
.language-dialog {
  .el-dialog {
    border-radius: 8px;

    &__header {
      padding-left: 35px;
      text-align: left;
      height: 40px; /* 设置固定高度 */
      display: flex;
      align-items: center; /* 垂直居中 */

      .el-dialog__title {
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #333333;
        letter-spacing: 0;
        font-weight: 600;
      }
    }

    &__body {
      padding: 30px 20px;
    }
  }

  .language-dialog-content {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100px;
  }

  .language-buttons {
    display: flex;
    gap: 20px;
    justify-content: center;
    width: 100%;

    .el-button {
      padding: 10px 25px;
      min-width: 100px;
      background-color: #F4F3F1;
      color: #AA81FF;
      border: 1px solid #AA81FF;
    }
    .el-button:hover {
      background-color: #e0e0e0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/layout/v2/espAside.vue